// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__8R-9Z","footerTop":"Footer_footerTop__nDkWb"};